import { jwtDecode } from "jwt-decode";

export const getUserRole = () => {
  const token = localStorage.getItem('token');
  
  if (!token) return null;
  
  try {
    const decoded = jwtDecode(token);
    const roles = decoded.roles || [];
    
    // Check if user is alpaca-staff (full access)
    if (roles.includes('alpaca-staff')) {
      return 'alpaca-staff';
    }
    
    // Check if user is a teacher (limited access)
    if (roles.includes('teacher')) {
      return 'teacher';
    }
    
    return null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const isTeacher = () => getUserRole() === 'teacher';
export const isAlpacaStaff = () => getUserRole() === 'alpaca-staff';

// Get the current user's own id from the token
export const getUserIdFromToken = () => {
  const token = localStorage.getItem('token');

  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.id || null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Get schoolId from token for teachers
export const getSchoolIdFromToken = () => {
  const token = localStorage.getItem('token');
  
  if (!token) return null;
  
  try {
    const decoded = jwtDecode(token);
    return decoded.schoolId || null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};